module.exports = __webpack_public_path__ + "img/5ee8c24.jpg";